import { actionTypes } from "./actions";

const initialState = {
  data: [],
  geoTreeEdit: {
    PositionCode: "",
    ParentPositionDescription: "",
    Position_EmployeeSK: "",
    Position_JobFunctionSK: "",
    Position_PositionSk: "",
    ParentPositionSk: "",
    PositionSK: "",
    EmployeeName: "",
    JobFunctionCode: "",
    JobFunctionDescription: "",
  },
  employees: [],
  jobFunctions: [],
  jobFunctionsFilterData: [],
  positions: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_GEOTREES:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_GEOTREE_BY_ID:
      return {
        ...state,
        geoTreeEdit: payload,
      };

    case actionTypes.SET_EDIT_FORM_CHANGE:
      return {
        ...state,
        geoTreeEdit: {
          ...state.geoTreeEdit,
          [payload.name]: payload.value,
        },
      };

    case actionTypes.SET_GEOTREE_FILTERED_RESULTS:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_JOB_FUNCTION:
      return {
        ...state,
        jobFunctions: payload,
      };

    case actionTypes.SET_POSITION_DESC:
      return {
        ...state,
        positions: payload,
      };

    case actionTypes.SET_EMPLOYEES:
      return {
        ...state,
        employees: payload,
      };

    case actionTypes.SET_JOB_FUNCTION_FILTER_DATA:
      return {
        ...state,
        jobFunctionsFilterData: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
